import styled from 'styled-components';

export const StyledSettingsContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;

  @media ${({ theme }) => theme.media.maxSm} {
    padding: 1rem;
  }
`;

export const StyledTitle = styled.h1`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 2rem 0;

  @media ${({ theme }) => theme.media.maxSm} {
    font-size: 1.75rem;
  }
`;

export const StyledSection = styled.div`
  margin-bottom: 2rem;
`;

export const StyledSectionTitle = styled.h2`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledSettingCard = styled.div`
  padding: 1.5rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.backgroundSecondary};
  margin-bottom: 1rem;

  @media ${({ theme }) => theme.media.maxSm} {
    padding: 1rem;
  }
`;

export const StyledSettingRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
`;

export const StyledFormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
`;

export const StyledSettingInfo = styled.div`
  flex: 1;
`;

export const StyledSettingLabel = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
  margin-bottom: 0.25rem;
`;

export const StyledSettingDescription = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.875rem;
`;

export const StyledToggleButton = styled.button<{ $active: boolean }>`
  position: relative;
  width: 3rem;
  height: 1.5rem;
  border: none;
  border-radius: 0.75rem;
  background: ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.border)};
  cursor: pointer;
  transition: all 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ $active }) => ($active ? '26px' : '2px')};
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: white;
    transition: all 0.2s ease;
  }
`;

export const StyledSelect = styled.select`
  padding: 0.75rem 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.backgroundSecondary};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 150px;
  position: relative;
  z-index: 1;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary}20;
  }

  option {
    background: ${({ theme }) => theme.colors.backgroundSecondary};
    color: ${({ theme }) => theme.colors.textPrimary};
    padding: 0.5rem;
    font-size: 0.875rem;

    &:checked {
      background: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.textInverse};
    }
  }
`;

export const StyledInput = styled.input<{ $disabled?: boolean }>`
  padding: 0.75rem 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  background: ${({ theme, $disabled }) => ($disabled ? `${theme.colors.border}50` : theme.colors.backgroundSecondary)};
  color: ${({ theme, $disabled }) => ($disabled ? theme.colors.textSecondary : theme.colors.textPrimary)};
  font-size: 0.875rem;
  width: 100%;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'text')};

  &:focus {
    outline: none;
    border-color: ${({ theme, $disabled }) => ($disabled ? theme.colors.border : theme.colors.primary)};
    box-shadow: ${({ theme, $disabled }) => ($disabled ? 'none' : `0 0 0 3px ${theme.colors.primary}20`)};
  }
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
